(function () {
  'use strict';
  if (window.__junisProductInfoLoaded) return;
  window.__junisProductInfoLoaded = true;

  window.__junisProductInfoFetch = window.__junisProductInfoFetch || ((sku) => {
    window.__junisProductInfoCache = window.__junisProductInfoCache || new Map();
    const cache = window.__junisProductInfoCache;
    if (!cache.has(sku)) {
      cache.set(
        sku,
        (window.junisFetch || fetch)(`/apps/wishtrade/product-info?sku=${encodeURIComponent(sku)}`, {
          headers: { Accept: 'application/json' },
          junisTimeout: 8000,
          junisRetries: 1,
        })
          .then((r) => {
            if (r.ok) return r.json();
            // 404 = 미등록(영구) → null 캐시 유지. 그 외(5xx/429) = 일시 → 캐시 제거(재시도 허용).
            if (r.status !== 404) cache.delete(sku);
            return null;
          })
          .catch(() => {
            // 네트워크/타임아웃 = 일시 → 캐시 제거(다음 호출 재시도 허용).
            cache.delete(sku);
            return null;
          }),
      );
    }
    return cache.get(sku);
  });

  const escape = (s) =>
    String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const pendingHtml = () => '<span class="jpi__pending">Not registered</span>';

  const renderCode = (val) => `<span class="jpi__value--code">${escape(val)}</span>`;

  const renderMsrp = (meta, cartCurrency) => {
    const msrp = meta && meta.msrp;
    const cur = String(cartCurrency || 'USD').toUpperCase();
    let amount = null;
    let currency = 'USD';
    if (msrp && msrp[cur] != null) {
      amount = msrp[cur];
      currency = cur;
    } else if (msrp && msrp.USD != null) {
      amount = msrp.USD;
    } else if (meta && meta.msrpUsd != null) {
      amount = meta.msrpUsd;
    }
    if (amount == null || amount === 0) return pendingHtml();
    const num = Number(amount);
    if (!isFinite(num)) return pendingHtml();
    let formatted;
    try {
      // narrowSymbol = USD '$' · KRW '₩' · JPY '¥'.
      formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(num);
    } catch (_e) {
      formatted = `${currency} ${num}`;
    }
    return `<span class="jpi__value--currency">${escape(formatted)}</span>`;
  };

  const renderQty = (val) => {
    if (val == null || val < 1) return pendingHtml();
    return `<span class="jpi__value--unit">${escape(val)}<span class="jpi__unit-suffix">units / carton</span></span>`;
  };

  const renderText = (val) => (val ? escape(val) : pendingHtml());

  const fillField = (card, field, html) => {
    const dd = card.querySelector(`dd[data-field="${field}"]`);
    if (dd) dd.innerHTML = html;
  };

  const hydrate = async (card) => {
    const sku = card.dataset.sku;
    if (!sku) return;

    let meta = null;
    try {
      meta = await window.__junisProductInfoFetch(sku);
    } catch {
      // 조회 실패 시 기본 표시 유지
    }

    if (!meta) {
      fillField(card, 'lineUp', pendingHtml());
      fillField(card, 'hsCode', pendingHtml());
      fillField(card, 'msrpUsd', pendingHtml());
      const qtyDd = card.querySelector('dd[data-field="qtyPerCarton"]');
      if (qtyDd && qtyDd.querySelector('.jpi__pending')) {
        qtyDd.innerHTML = pendingHtml();
      }
      return;
    }

    fillField(card, 'lineUp', renderText(meta.lineUp));
    fillField(card, 'hsCode', meta.hsCode ? renderCode(meta.hsCode) : pendingHtml());
    // 거래처 통화 = liquid cart.currency(data-cart-currency) 우선, 비면 Shopify.currency.active fallback
    //   (빈 cart.currency 엣지케이스 방어 · 로그인 B2B 는 active=거래처 통화). 둘 다 없으면 USD.
    const cartCurrency =
      card.dataset.cartCurrency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
    fillField(card, 'msrpUsd', renderMsrp(meta, cartCurrency));

    // qtyPerCarton: Liquid 에서 이미 채웠으면 유지
    const qtyDd = card.querySelector('dd[data-field="qtyPerCarton"]');
    if (qtyDd && qtyDd.querySelector('.jpi__pending')) {
      qtyDd.innerHTML = renderQty(meta.qtyPerCarton);
    }
  };

  const init = () => {
    document.querySelectorAll('.jpi[data-sku]').forEach(hydrate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // 온라인 복귀 시 재hydrate. 로 실패(일시) SKU 는 캐시에서 제거됐으므로
  //   재init 시 그 SKU 만 재요청(성공 SKU 는 cache hit). 'Not registered' 로 굳은 카드 자동 회복.
  window.addEventListener('online', init);
})();
